import api from "@/lib/api";

const MAX_BYTES = 5 * 1024 * 1024;
const ACCEPTED_TYPES = ["image/jpeg", "image/png", "image/webp", "image/gif", "image/heic", "image/heif"];

export const IMAGE_ACCEPT = "image/jpeg,image/png,image/webp,image/gif,image/heic,image/heif,.heic,.heif";

// Validate and upload an image file to the backend (which stores it on Google Drive).
export async function uploadImage(file) {
    // Browsers sometimes send empty Content-Type for HEIC; fall back to filename
    const name = (file.name || "").toLowerCase();
    const looksLikeHeic = name.endsWith(".heic") || name.endsWith(".heif");
    if (!ACCEPTED_TYPES.includes(file.type) && !looksLikeHeic) {
        throw new Error("Unsupported image type. Use JPG, PNG, WebP, GIF, or HEIC.");
    }
    if (file.size > MAX_BYTES) {
        throw new Error("File too large. Max 5 MB.");
    }
    const fd = new FormData();
    fd.append("file", file);
    const { data } = await api.post("/admin/uploads", fd, {
        headers: { "Content-Type": "multipart/form-data" },
    });
    return data.url;
}
